// 2020-06-27export { ScrollTopComponent } from './scroll-top.component';